module.exports = __webpack_public_path__ + "static/media/s2opaquebluepad.bd29511f.jpg";